// extracted by mini-css-extract-plugin
module.exports = {"longformContentSection":"style_longformContentSection__MxJft g-type-body-long blockquote_blockquote__pvK2y hr_hr__MX7C_ ol-ul-lists_olUlLists__bhxBm"};